import React from 'react'

const Contactme = (props) => {
    return (
        <div style={{display:'flex',flexDirection:'column', gap:'10px', padding:'1%'}}>
            <div style={{fontSize:'24px',textAlign:'center',marginBottom:3}}>CONNECT WITH ME</div>
            <div style={{display:'flex',justifyContent:'center',gap:'5%'}}>
                <div ><a href='https://www.linkedin.com/in/sharangahirekar1/'><img src="linkedin-icon-white.jpg" width='100px' alt=""/></a></div>
                <div ><a href='https://github.com/sharangahirekar1'><img src="github-icon.png" width='30px' alt=""/></a></div>
                {/* <div ><a href='https://twitter.com/Sharang010'><img src="twitter-icon.png" width='30px' alt=""/></a></div> */}
                <div style={{textAlign:'center'}}><img src='./WhatsApp.svg.png' width='30px' alt='whatsapp'/> : +91 98885 39637</div>
            </div>
            
        </div>
    )
}

export default Contactme;